import React from 'react';
import { Header } from '../Header';
import { Icon } from '../Icon';
import styles from './styles.scss';
export var SettingsButton = function SettingsButton(_ref) {
  var onClick = _ref.onClick;
  return React.createElement("div", {
    className: styles.footer
  }, React.createElement(Header, {
    variant: "h5"
  }, "Settings"), React.createElement("div", {
    role: "button",
    className: styles.arrow,
    onClick: onClick,
    "data-test": "show-settings-button"
  }, React.createElement(Icon, {
    icon: "arrow-right",
    ariaLabel: "Show Settings"
  })));
};
SettingsButton.defaultProps = {
  onClick: function onClick() {}
};